import React from 'react'
import { Link, useParams } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import ProductCards from '../components/ProductCards'
import Icon from '../components/Icons'
import Reveal from '../components/Reveal'
import { products } from '../data/site'
import { CallToAction } from './Home'

const Products = () => {
  const { slug } = useParams()
  const product = products.find((item) => item.slug === slug)

  if (slug && product) return <ProductDetail product={product} />
  if (slug) return <main><PageHeader index="Products" label="Not found" lines={['That product', 'is not available.']} crumb="Products" /></main>

  return (
    <main>
      <PageHeader index="Products" label="Our product suite" lines={['One ecosystem.', <>Unlimited <span className="accent-italic">possibilities.</span></>]} description="Six production platforms designed to make operations, payments and customer experiences work better together." crumb="Products" />
      <section className="section bg-ink-950">
        <div className="container"><ProductCards detailed /></div>
      </section>
      <CallToAction />
    </main>
  )
}

const ProductDetail = ({ product }) => (
  <main>
    <section className="relative overflow-hidden bg-ink-950 pt-36 text-paper-100 md:pt-44">
      <div className="container relative pb-24 md:pb-32">
        <p className="label label-dark">{product.name} · {product.category}</p>
        <h1 className="display-1 mt-8 max-w-5xl text-paper-100">{product.headline}</h1>
        <p className="mt-10 max-w-2xl text-lg leading-relaxed text-paper-100/60">{product.sub}</p>
        <div className="mt-10 flex flex-wrap gap-3">
          {product.href ? <a href={product.href} target="_blank" rel="noreferrer" className="btn btn-light">Visit {product.name} <Icon name="arrow" className="h-4 w-4" /></a> : <Link to="/contact" className="btn btn-light">Book a demo <Icon name="arrow" className="h-4 w-4" /></Link>}
          <Link to="/contact" className="btn btn-ghost-dark">Talk to sales</Link>
        </div>
      </div>
    </section>
    <section className="section bg-paper-50">
      <div className="container grid gap-14 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal><span className="label">Why teams choose it</span><h2 className="display-2 mt-6">Built for practical, accountable delivery.</h2></Reveal>
        <Reveal delay={100}><ul className="space-y-5 border-y border-ink-950/10 py-2">{product.highlights.map((item, index) => <li key={item} className="flex gap-5 border-b border-ink-950/10 py-5 last:border-0"><span className="index-num" style={{ color: product.accent }}>{String(index + 1).padStart(2, '0')}</span><span className="text-lg text-ink-500">{item}</span></li>)}</ul></Reveal>
      </div>
    </section>
    {product.features && <section className="section bg-paper-100">
      <div className="container">
        <Reveal><span className="label">Platform capabilities</span><h2 className="display-2 mt-6 max-w-3xl">Everything your team needs, in one place.</h2></Reveal>
        <div className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-ink-950/10 bg-ink-950/10 md:grid-cols-2 lg:grid-cols-3">
          {product.features.map((feature, index) => <Reveal key={feature.title} delay={index * 55} className="bg-paper-100 p-7"><span className="index-num" style={{ color: product.accent }}>{String(index + 1).padStart(2, '0')}</span><h3 className="mt-5 font-display text-2xl font-semibold tracking-tighter2">{feature.title}</h3><p className="mt-3 leading-relaxed text-ink-500">{feature.body}</p></Reveal>)}
        </div>
      </div>
    </section>}
    {product.modules && <section className="section bg-ink-950 text-paper-100"><div className="container grid gap-10 lg:grid-cols-[0.8fr_1.2fr]"><Reveal><span className="label label-dark">Complete suite</span><h2 className="display-2 mt-6">Every essential module, connected.</h2></Reveal><Reveal delay={100} className="flex flex-wrap content-start gap-3">{product.modules.map((module) => <span key={module} className="rounded-full border border-paper-100/15 px-4 py-2.5 text-sm text-paper-100/75">{module}</span>)}</Reveal></div></section>}
    <section className="section bg-ink-950"><div className="container"><p className="label label-dark mb-8">Explore the suite</p><ProductCards /></div></section>
    <CallToAction />
  </main>
)

export default Products
